import FleetElectrification from '@/models/scenario/rules/FleetElectrification.js'
import AnnualCollectiveQuota from '@/models/scenario/rules/AnnualCollectiveQuota.js'
import CarElectrification from '@/models/scenario/rules/CarElectrification.js'
import Carpooling from '@/models/scenario/rules/Carpooling.js'
import ChangeHeating from '@/models/scenario/rules/ChangeHeating.js'
import IncreaseDevicesLifetime from '@/models/scenario/rules/IncreaseDevicesLifetime.js'
import IncreaseInstrumentsLifetime from '@/models/scenario/rules/IncreaseInstrumentsLifetime.js'
import InsulateBuilding from '@/models/scenario/rules/InsulateBuilding.js'
import LimitPlane from '@/models/scenario/rules/LimitPlane.js'
import ReduceHeating from '@/models/scenario/rules/ReduceHeating.js'
import ReducePurchase from '@/models/scenario/rules/ReducePurchase.js'
import ReplaceCar from '@/models/scenario/rules/ReplaceCar.js'
import ReplacePlane from '@/models/scenario/rules/ReplacePlane.js'
import ReplacePlaneNational from '@/models/scenario/rules/ReplacePlaneNational.js'
import SecondHandPurchase from '@/models/scenario/rules/SecondHandPurchase.js'
import SelfConsumption from '@/models/scenario/rules/SelfConsumption.js'
import Teleworking from '@/models/scenario/rules/Teleworking.js'
import ChangeDiet from '@/models/scenario/rules/ChangeDiet.js'

export const RULES_CLASSES = {
  FleetElectrification,
  AnnualCollectiveQuota,
  CarElectrification,
  Carpooling,
  ChangeHeating,
  IncreaseDevicesLifetime,
  IncreaseInstrumentsLifetime,
  InsulateBuilding,
  LimitPlane,
  ReduceHeating,
  ReducePurchase,
  ReplaceCar,
  ReplacePlane,
  ReplacePlaneNational,
  SecondHandPurchase,
  SelfConsumption,
  Teleworking,
  ChangeDiet
}

export function getBuiltRules (rules) {
  let _rules = rules
  if (_rules === null || _rules === undefined) {
    _rules = Object.keys(RULES_CLASSES)
  }

  return Object.keys(RULES_CLASSES)
    .filter((name) => _rules.includes(name))
    .map((name) => new RULES_CLASSES[name]())
}

export function rulesFactory (name) {
  return RULES_CLASSES[name]
}
